define([
    './defined',
    './defaultValue',
    '../System/Vec3Obj',
    '../System/CircleObj',
    '../System/WayPoint'
    // 根据需要导入其他对象类型
], function (
    defined,
    defaultValue,
    Vec3Obj,
    CircleObj,
    WayPoint
    // 其他导入的类型
) {
    'use strict'

    /**
     * 通用JSON解析器，可以将不同类型的JSON字符串转换为相应的对象数组
     *
     * @private
     *
     * @exports jsonObjectParser
     */
    const jsonObjectParser = {};

    // 存储不同类型的解析处理函数
    const typeHandlers = {};

    /**
     * 注册新的类型处理器
     * @param {String} type - JSON对象中的类型标识
     * @param {Function} handler - 处理该类型的函数，接收item对象和额外选项
     */
    jsonObjectParser.registerTypeHandler = function (type, handler) {
        if (typeof handler === 'function') {
            typeHandlers[type] = handler;
        }
    };

    /**
     * 解析JSON字符串为对象数组
     * @param {String} jsonString - 要解析的JSON字符串
     * @param {Object} options - 额外选项，传递给类型处理器
     * @return {Array} 解析后的对象数组
     */
    jsonObjectParser.parse = function (jsonString, options) {
        let result = [];
        options = defaultValue(options, {});

        try {
            // 解析JSON字符串为JavaScript对象
            const jsonObj = JSON.parse(jsonString);

            if (defined(jsonObj.type) && Array.isArray(jsonObj.array)) {
                const type = jsonObj.type;
                const handler = typeHandlers[type];

                if (handler) {
                    // 使用注册的处理器处理每个元素
                    for (let i = 0; i < jsonObj.array.length; ++i) {
                        const obj = handler(jsonObj.array[i], options);
                        if (defined(obj)) {
                            result.push(obj);
                        }
                    }
                } else {
                    console.warn('未找到类型 "' + type + '" 的处理器');
                }
            } else {
                console.warn('JSON格式不正确，缺少type或array字段');
            }
        } catch (e) {
            console.error('解析JSON字符串失败:', e);
        }

        return result;
    };

    // 预注册几种常见类型

    // 注册TUPLE3D类型处理器
    jsonObjectParser.registerTypeHandler('TUPLE3D', function (item, options) {
        if (defined(item.x) && defined(item.y) && defined(item.z)) {
            return new Vec3Obj(item.x, item.y, item.z);
        }
        return undefined;
    });
    // 注册FLOAT类型处理器
    jsonObjectParser.registerTypeHandler('FLOAT', function (item, options) {
        if (typeof item === 'number') {
            return item; // 直接返回数字
        }
        return undefined;
    });
    // 注册COMPOSITE类型处理器
    jsonObjectParser.registerTypeHandler('COMPOSITE', function (item, options) {
        if (defined(item.radius) && defined(item.color) &&
            defined(item.textColor) && defined(item.text)) {
            return new CircleObj(
                item.radius,
                item.color,
                item.text,
                item.textColor,
            );
        } else if(defined(item.position) && defined(item.radius) && defined(item.orientation)){
            return new WayPoint(
                item.position,
                item.radius,
                item.orientation
            );
        }
        return undefined;
    });

    return jsonObjectParser;
});